import React, { useRef, useState, useEffect } from 'react';
import ReactResizeDetector from 'react-resize-detector';
import debounce from 'lodash.debounce';
import { getHost, getHostImage, getHostVideo } from './../Helpers/HostInfo'; 
import ChristmasBG from './../Basic/ChristmasBG';
import styles from './../../../../Css/Components/background.css';
import evMgr from './../../../helper/eventsHelper';


const desktopMinWidth = 768;
const hostBGs = [];
const portraitPhoto = {
    type: 'portrait',
    width: 440
};
const desktopPhoto = {
    type: 'landscape',
    width: 1280
};
let hostBGIndex = 0;
let firstRender = true;
const hostVideo = {};
const videoTypes = {
    intro: "introvideo",
    promo: "hostpromovideo"
};

function Background(props) {
    const [containerHeight, setContainerHeight] = useState(0);
    const [hostVideoBG, setHostVideoBG] = useState(undefined);
    const [hostImageBG, setHostImageBG] = useState(undefined);

    let style = {
        'backgroundColor': props.color,
        'backgroundImage': props.image && !props.host && !(props.overlay == "christmas") ? `url(${props.image})` : "",
        'minHeight': `${containerHeight}px`,
        'height': `${props.height}`,
        'width': `${props.width}`
    };

    const contentEl = useRef(null);
    const bgEl = useRef(null);
    const bgVideoEl = useRef(null);

    const hostMediaBG = props.host ? 'host-media-bg' : '';
    const wrapperClasses = `background-component-wrapper ${props.overlay} ${hostMediaBG}`;

   
    function onResize() {
        const childHeight = contentEl.current.clientHeight;
        setContainerHeight(childHeight);
    }

    function setHostPhotoAsBG() {
        const proplist = props.noNude ? 'bustandcup,asssize,buildid,aboutme,photosjson,ms_mainimg' : null;
        getHost(props.host, proplist).then(response => response.json())
            .then(res => {
                let photos = JSON.parse(res.Response.Data.Room.PropList.photosjson);
                const photoType = contentEl.current.clientWidth >= desktopMinWidth ? desktopPhoto : portraitPhoto;
                
                if(props.noNude){
                    if(res.Response.Data.Room.PropList.ms_mainimg){
                        hostBGs.push({
                            src: getHostImage(res.Response.Data.Room.PropList.ms_mainimg),
                            filename: res.Response.Data.Room.PropList.ms_mainimg
                        });
                        setHostImageAsBG();
                        return;
                    }else{
                        const priority = {
                            "nse_main": 0,
                            "nse_fivephotos": 1
                        };

                        photos = photos.sort((a, b) => {
                            const aPriority = priority.hasOwnProperty(a.label) ? priority[a.label] : 2;
                            const bPriority = priority.hasOwnProperty(b.label) ? priority[b.label] : 2;
                          
                            return aPriority - bPriority;
                        });
                    }
                }

                photos.forEach((photo) => {
                    for (let i = 0; i < hostBGs.length; i++) {
                        if (hostBGs[i].filename == photo.filename) {
                            return;
                        }
                    }
                    const imageSizes = JSON.parse(photo.image_sizes);
                    for (let i = 0; i < imageSizes.length; i++) {
                        imageSizes[i].simpleType = imageSizes[i].width / imageSizes[i].height > 1 ?
                            desktopPhoto.type : portraitPhoto.type;
                        if (imageSizes[i].simpleType == photoType.type && imageSizes[i].width >= photoType.width) {
                            let height = Math.round(photoType.width * imageSizes[i].height / imageSizes[i].width);
                            let src = getHostImage(photo.filename, imageSizes[i].type, photoType.width, height);
                            hostBGs.push({
                                src: src,
                                filename: photo.filename
                            });
                            break;
                        }
                    }
                });
                setHostImageAsBG();
            });
    }

    if (props.host) {
        useEffect(() => {
            if (props.hvt) {
                getHostVideo(props.host).then(response => response.json())
                    .then(res => {
                        const videos = res.Response.Data.Videos;
                        if (videos) {
                            if (videos.Video.length) {
                                videos.Video.forEach((video) => {
                                    hostVideo[video.name] = video.url;
                                });
                            } else {
                                hostVideo[videos.Video.name] = videos.Video.url;
                            }
                            if (hostVideo[videoTypes[props.hvt]]) {
                                setHostVideoBG(hostVideo[videoTypes[props.hvt]]);
                            } else {
                                for (let key in hostVideo) {
                                    if (hostVideo.hasOwnProperty(key)) {
                                        setHostVideoBG(hostVideo[key]);
                                        break;
                                    }
                                }
                            }
                        } else {
                            //if no video fallback to host photo
                            setHostPhotoAsBG();
                        }
                    });
            } else {
                setHostPhotoAsBG();
            }
            firstRender = false;
        }, []);
    }

    useEffect(() => {

        if (props.fixeBackgroundImage) {
            bgEl.current.style.backgroundImage = `url(${props.fixeBackgroundImage})`;
            setHostImageBG(props.fixeBackgroundImage);
        }

        if (firstRender) {
            return;
        }
        if (hostBGIndex > hostBGs.length - 1) {
            hostBGIndex = 0;
        }
        setHostImageAsBG();
    }, [props.children]);

    useEffect(() => {
        if (hostVideoBG || hostImageBG || props.image) {
            if (typeof props.onLoad == 'function') {
                props.onLoad();
            }
        }
    }, [hostVideoBG, hostImageBG, props.image]);



    function setHostImageAsBG() {
        if (hostBGs[hostBGIndex]) {
            bgEl.current.style.backgroundImage = `url(${hostBGs[hostBGIndex].src})`;
            setHostImageBG(hostBGs[hostBGIndex].src);
            hostBGIndex++;
        } 
    }

    evMgr.on('CHANGE_BG', (data) => {
        const url = data.url;
        if (url.indexOf('.png') > -1 || url.indexOf('.jpg') > -1) {
            bgEl.current.style.backgroundImage = `url(${url})`;
            bgVideoEl.current.style.display = 'none';
        }
        if (url.indexOf('.mp4') > -1) {
            bgEl.current.style.backgroundImage = 'none';
            bgVideoEl.current.src = url;
            bgVideoEl.current.style.display = 'block';
        }
        evMgr.off('CHANGE_BG');
    })

    return (

        <div style={style} className={wrapperClasses} ref={bgEl} data-host-media-bg={hostVideoBG || hostImageBG}>
            {/* props video background */}
            {props.video && !props.host &&
                <video muted loop autoPlay playsInline className="background-component-video" ref={bgVideoEl}>
                    <source src={props.video} type="video/mp4" />
                </video>
            }

            {/* host video background */}
            {props.host && hostVideoBG &&
                <video muted loop autoPlay playsInline className="background-component-video">
                    <source src={hostVideoBG} type="video/mp4" />
                </video>
            }
            {/* props christmas video background */}
            {props.overlay == 'christmas' &&
                <video muted loop autoPlay playsInline className="background-component-video" ref={bgVideoEl}>
                    <source src={props.video} type="video/mp4" />
                </video>
            }

            {props.overlay && (
                props.link ? <a className="overlay" href={props.link}></a> : <div className="overlay"></div>
            )}
            {props.overlay == "christmas" && (
                <ChristmasBG/>
               )
            }
            <div className="background-component-content" ref={contentEl}>
                {props.children}
                {props.watchResize &&
                    <ReactResizeDetector
                        handleWidth handleHeight
                        onResize={debounce(onResize, 100, { 'maxWait': 1000 })}
                    />
                }
            </div>
        </div>
    );
}

export default Background;